import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Tab, Tabs } from "react-bootstrap";

import BuscadorAvanzadoTomo1 from "../buscadorPublicacionesPage/buscadorAvanzadoTomo1";
import BuscadorAvanzadoTomo2 from "../buscadorPublicacionesPage/buscadorAvanzadoTomo2";
import BuscadorAvanzadoTomo3 from "../buscadorPublicacionesPage/buscadorAvanzadoTomo3";
import ResultadosBusquedaTomos from "../buscadorPublicacionesPage/components/resultadosBusquedaTomos";

import DescargaTomo1 from "./components/DescargaTomo1";
import DescargaTomo2 from "./components/DescargaTomo2";
import DescargaTomo3 from "./components/DescargaTomo3";

import BopiHistorico from "../../components/bopiHistorico/BopiHistorico";
import PestanaAyuda from "../../components/ayuda/Ayuda";

import Spinner from "../../components/spinner/spinner";
import { AlertRenderer } from "../../components/alert/AlertRenderer";
import { useAlert } from "../../context/AlertContext";

import "./DescargaTomosPage.css";

import { useLocation, useNavigate } from "react-router-dom";


const DescargaTomosPage = ({
  activeTab,
  setActiveTab,
  activeInnerTab,
  setActiveInnerTab
}) => {

  const location = useLocation();

  useEffect(() => {
    // desde aplicacionies externas es necesario acceder directamente a descarga o buscador. Es necesario esto además de meter la ruta en el router:
    //   según de donde venga, pongo el tab activo y voy a la url común de siempre:
    if (location.pathname === "/descarga") {
      setActiveTab("descarga");
      navigate("/");
    }

    if (location.pathname === "/buscador") {
      setActiveTab("buscador");
      navigate("/");
    }
  }, [location.pathname]);
  
  const navigate = useNavigate();

  const [resultadosTomo1, setResultadosTomo1] = useState([]);
  const [resultadosTomo2, setResultadosTomo2] = useState([]);
  const [resultadosTomo3, setResultadosTomo3] = useState([]);

  const [bBusquedaRealizada1, setBusquedaRealizada1] = useState(false);
  const [bBusquedaRealizada2, setBusquedaRealizada2] = useState(false);
  const [bBusquedaRealizada3, setBusquedaRealizada3] = useState(false);

  const [parametrosBusquedaTomo1, setParametrosBusquedaTomo1] = useState([]);
  const [parametrosBusquedaTomo2, setParametrosBusquedaTomo2] = useState([]);
  const [parametrosBusquedaTomo3, setParametrosBusquedaTomo3] = useState([]);

  const [resultadosTotalesTomo1, setResultadosTotalesTomo1] = useState(0);
  const [resultadosTotalesTomo2, setResultadosTotalesTomo2] = useState(0);
  const [resultadosTotalesTomo3, setResultadosTotalesTomo3] = useState(0);

  const manejarParametrosBusquedaTomo1 = (onSearchData) => {
    setParametrosBusquedaTomo1(onSearchData);
  };

  const manejarParametrosBusquedaTomo2 = (onSearchData) => {
    setParametrosBusquedaTomo2(onSearchData);
  };

  const manejarParametrosBusquedaTomo3 = (onSearchData) => {
    setParametrosBusquedaTomo3(onSearchData);
  };

  const manejarResultadosTotalesTomo1 = (resultadosTotales) => {
    setResultadosTotalesTomo1(resultadosTotales);
  };

    const manejarResultadosTotalesTomo2 = (resultadosTotales) => {
    setResultadosTotalesTomo2(resultadosTotales);
  };

    const manejarResultadosTotalesTomo3 = (resultadosTotales) => {
    setResultadosTotalesTomo3(resultadosTotales);
  };

  const manejarResultadosTomo1 = (resultados) => {
    setResultadosTomo1(resultados);
    setBusquedaRealizada1(true);
  };

  const manejarResultadosTomo2 = (resultados) => {
    setResultadosTomo2(resultados);
    setBusquedaRealizada2(true);
  };

  const manejarResultadosTomo3 = (resultados) => {
    setResultadosTomo3(resultados);
    setBusquedaRealizada3(true);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const titulosTomos = {
    Tomo1: "Tomo 1: Marcas y otros signos distintivos",
    Tomo2: "Tomo 2: Invenciones",
    Tomo3: "Tomo 3: Diseños industriales"
  };

  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);

  const buscadorTomo1Ref = useRef(null);
  const buscadorTomo2Ref = useRef(null);
  const buscadorTomo3Ref = useRef(null);

  const [cargando1, setCargando1] = useState(false);
  const [cargando2, setCargando2] = useState(false);
  const [cargando3, setCargando3] = useState(false);

  const { closeAlert } = useAlert();

  const handleInnerSelect = (eventKey) => {
    setActiveInnerTab(eventKey);
    closeAlert();
  };

  const renderTabsMenu = () => (
    <div className="tabs-container border-bottom">
      <div className="ancho-tabs">

        <div
          className={`${activeTab === "descarga" || isHovered1
            ? "underline-yellow activo-span p-3 shadow text-center me-2"
            : "desactivo-span p-3 me-2"
          } ancho-tab`}
          onClick={() => setActiveTab("descarga")}
          onMouseEnter={() => setIsHovered1(true)}
          onMouseLeave={() => setIsHovered1(false)}
          style={{ cursor: 'pointer' }}
        >
          <h2 className="m-0">Descarga de publicaciones</h2>
        </div>

        <div
          className={`${activeTab === "buscador" || isHovered2
            ? "underline-yellow activo-span p-3 shadow text-center mx-2"
            : "desactivo-span p-3 mx-2"
          } ancho-tab`}
          onClick={() => setActiveTab("buscador")}
          onMouseEnter={() => setIsHovered2(true)}
          onMouseLeave={() => setIsHovered2(false)}
          style={{ cursor: 'pointer' }}
        >
          <h2 className="m-0">Buscador de publicaciones</h2>
        </div>

        <div
          className={`${activeTab === "historico" || isHovered3
            ? "underline-yellow activo-span p-3 shadow text-center mx-2"
            : "desactivo-span p-3 mx-2"
          } ancho-tab`}
          onClick={() => setActiveTab("historico")}
          onMouseEnter={() => setIsHovered3(true)}
          onMouseLeave={() => setIsHovered3(false)}
          style={{ cursor: 'pointer' }}
        >
          <h2 className="m-0">BOPI histórico</h2>
        </div>

        <div
          className={`${activeTab === "ayuda" || isHovered4
            ? "underline-yellow activo-span p-3 shadow text-center ms-2"
            : "desactivo-span p-3 ms-2"
          } ancho-tab`}
          onClick={() => {setActiveTab("ayuda")}}
          onMouseEnter={() => setIsHovered4(true)}
          onMouseLeave={() => setIsHovered4(false)}
          style={{ cursor: 'pointer' }}
        >
          <h2 className="m-0">Ayuda</h2>
        </div>

      </div>
    </div>
  );

  return (
    <Row className="m-0 mt-1 p-0 pt-4 espacios-generales">
      <Col className="m-0 p-0">

        {!isMobile && renderTabsMenu()}

        <div className="mobile-page-header ancho-tabs">
          <div className="ancho-tab">
            <div className="underline-yellow activo-span p-3 text-center">

              {activeTab === "descarga" && (
                <>
                  <h2 className="fs-2">Descarga de publicaciones</h2>
                  <h3 className="fs-3">{titulosTomos[activeInnerTab]}</h3>
                </>
              )}

              {activeTab === "buscador" && (
                <>
                  <h2 className="fs-2">Buscador de publicaciones</h2>
                  <h3 className="fs-3">{titulosTomos[activeInnerTab]}</h3>
                </>
              )}

              {activeTab === "historico" && <h2 className="fs-2">BOPI histórico</h2>}
              {activeTab === "ayuda" && <h2 className="fs-2">Ayuda</h2>}

            </div>
          </div>
        </div>

        <div className="tab-content mt-3">

          {activeTab === "descarga" && (
            <Tabs activeKey={activeInnerTab} onSelect={handleInnerSelect} fill
            className="w-100">
              <Tab
                eventKey="Tomo1"
                title={<span className="d-block w-100 text-center">{titulosTomos.Tomo1}</span>}
              >
                <DescargaTomo1 />
              </Tab>

              <Tab
                eventKey="Tomo2"
                title={<span className="d-block w-100 text-center">{titulosTomos.Tomo2}</span>}
              >
                <DescargaTomo2 />
              </Tab>

              <Tab
                eventKey="Tomo3"
                title={<span className="d-block w-100 text-center">{titulosTomos.Tomo3}</span>}
              >
                <DescargaTomo3 />
              </Tab>
            </Tabs>
          )}

          {activeTab === "buscador" && (
            <Tabs activeKey={activeInnerTab} onSelect={handleInnerSelect} fill className="w-100">
              <Tab eventKey="Tomo1" title={<span className="d-block w-100 text-center">{titulosTomos.Tomo1}</span>}>
                <AlertRenderer />
                <BuscadorAvanzadoTomo1 ref={buscadorTomo1Ref} onResultados={manejarResultadosTomo1} 
                setCargando1={setCargando1} setBusquedaRealizada1={setBusquedaRealizada1} 
                onSearchData={manejarParametrosBusquedaTomo1} resultadosTotales={manejarResultadosTotalesTomo1}/>
                {cargando1 && <Spinner />}
                
                {bBusquedaRealizada1 && (
                    <Row className="m-0 p-0">
                      <Col xs={12} className="m-0 p-0">
                        <div className="espacios-generales m-0 p-0">
                          <ResultadosBusquedaTomos
                            resultados={resultadosTomo1}
                            parametros={parametrosBusquedaTomo1}
                            resultadosTotales={resultadosTotalesTomo1}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}

              </Tab>

              <Tab eventKey="Tomo2" title={<span className="d-block w-100 text-center">{titulosTomos.Tomo2}</span>}>
                <AlertRenderer />
                <BuscadorAvanzadoTomo2 ref={buscadorTomo2Ref} onResultados={manejarResultadosTomo2} 
                setCargando2={setCargando2} setBusquedaRealizada2={setBusquedaRealizada2} 
                onSearchData={manejarParametrosBusquedaTomo2} resultadosTotales={manejarResultadosTotalesTomo2}/>
                {cargando2 && <Spinner />}
                {bBusquedaRealizada2 && (
                    <Row className="m-0 p-0 ">
                      <Col xs={12} className="m-0 p-0">
                        <div className="espacios-generales m-0 p-0">
                          <ResultadosBusquedaTomos
                            resultados={resultadosTomo2}
                            parametros={parametrosBusquedaTomo2}
                            resultadosTotales={resultadosTotalesTomo2}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
              </Tab>

              <Tab eventKey="Tomo3" title={<span className="d-block w-100 text-center">{titulosTomos.Tomo3}</span>}>
                <AlertRenderer />
                <BuscadorAvanzadoTomo3 ref={buscadorTomo3Ref} onResultados={manejarResultadosTomo3} 
                setCargando3={setCargando3} setBusquedaRealizada3={setBusquedaRealizada3} 
                onSearchData={manejarParametrosBusquedaTomo3} resultadosTotales={manejarResultadosTotalesTomo3}/>
                {cargando3 && <Spinner />}
                {bBusquedaRealizada3 && (
                    <Row className="m-0 p-0">
                      <Col xs={12} className="m-0 p-0">
                        <div className="espacios-generales m-0 p-0">
                          <ResultadosBusquedaTomos
                            resultados={resultadosTomo3}
                            parametros={parametrosBusquedaTomo3}
                            resultadosTotales={resultadosTotalesTomo3}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
              </Tab>
            </Tabs>
          )}

          {activeTab === "historico" && 
            <div >
              <br />
              <br />
              <div >
                <BopiHistorico />
                <br />
                <br />
                <br />
                <br />              
              </div>
            </div>
          }
          {activeTab === "ayuda" && 
            <div >
            <br />
            <br />
            <div >        
              <PestanaAyuda />
              <br />
                <br />
                <br />
                <br />              
              </div>
            </div>              
          }

        </div>
      </Col>
    </Row>
  );
};

export default DescargaTomosPage;